import React from 'react';
import { Grid, Slider, TextField } from '@mui/material';

const marks = [
    {
        value: 0,
        label: '0%',
    },
    {
        value: 100,
        label: '100%',
    },
];

const PlanAllocationOfAnnuitiesSlider = ({ value, handleSliderChange, handleLowerBoundTextBoxChange, handleUpperBoundTextBoxChange }) => (
    <div>
        <Grid spacing={3} container>
            <Grid item xs={2}>
                <TextField
                    id="filled-number"
                    type="number"
                    label={"Stability"}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={value}
                    onChange={handleLowerBoundTextBoxChange}
                />
            </Grid>
            <Grid item xs={8}>
                <Slider
                    value={value}
                    onChange={handleSliderChange}
                    aria-labelledby="discrete-slider-custom"
                    step={5}
                    valueLabelDisplay="auto"
                    marks={marks}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id="filled-number"
                    label={"Accumulation"}
                    type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={100 - value}
                    onChange={handleUpperBoundTextBoxChange}
                />
            </Grid>
        </Grid>
    </div>
);

export default PlanAllocationOfAnnuitiesSlider;
